import React from 'react';
import './style.sass';

// Input tipo android
export function InputTypeAndroidDos({ ...params }) {

    const {
        type,
        name,
        id,
        placeholder,
        value,
        change,
        onFocus,
        errorMessage,
        max,
        min,
        refs,
        readonly,
        disabled,
        autocomplete,
        children,
        maxLength,
        onKeyDown,
        onKeyUp,
        minLength,
        onChange,
        className = "",
        oncopy,
        onpaste
    } = params


    return (
        < div className={`fieldset2 ${className}`}>
            <input
                onChange={onChange}
                type={type}
                name={name}
                id={id}
                placeholder=" "
                onFocus={onFocus}
                value={value}
                // max={max}
                // min={min}
                readOnly={readonly}
                disabled={disabled}
                autoComplete={autocomplete}
                data-input={autocomplete}
                ref={refs}
                maxLength={maxLength}
                minLength={minLength}
                onKeyDown={onKeyDown}
                onKeyUp={onKeyUp}
                onCopy={oncopy}
                onPaste={onpaste}
            />
            <label htmlFor={id} for={id}>{placeholder}</label>
            {/* {children} */}

            {errorMessage
                ? <div className="error">{errorMessage}</div>
                : null
            }
        </div>
    )
}

// Input tipo android
export function InputTypeAndroid({ ...params }) {

    const {
        type,
        name,
        id,
        placeholder,
        value,
        change,
        focus,
        click,
        errorMessage,
        max,
        min,
        refs,
        readonly,
        disabled,
        autocomplete,
        children,
        maxLength,
        setNumero,
        className = "",
        onKeyDown,
        onKeyUp,
        minLength,
        pattern,
        numero
    } = params


    const handleNumero = (e) => {
        e.preventDefault();

        let numero = e.target.value;

        if (pattern === "number") {
            if (numero.length != 0) {
                setNumero(numero.replace(/[^\d]+/g, ''));
            } else {
                setNumero('');
            }
        } else {
            setNumero(numero);
        }
    }

    const onKeyDown1 = (e) => {
    // console.log("key: ", e.keyCode)
        if (String(pattern) === "number") {
            if (e.keyCode != 8 && 
                e.keyCode != 186 && 
                (e.keyCode < 48 || e.keyCode > 57) &&
                (e.keyCode < 96 || e.keyCode > 105 )
            ) {
                e.preventDefault();
            }
        }
    }


    return (
        <div className={`fieldset2 ${className}`}>
            <input
                type={type}
                name={name}
                id={id}
                placeholder=" "
                // onChange={change}
                onFocus={focus}
                onClick={click}
                value={value}
                max={max}
                min={min}
                readOnly={readonly}
                disabled={disabled}
                autoComplete={autocomplete}
                data-input={autocomplete}
                ref={refs}
                maxLength={maxLength}
                minLength={minLength}
                onChange={handleNumero}
                onKeyUp={onKeyUp}
                onKeyDown={onKeyDown1}
            />
            <label htmlFor={id} for={id}>{placeholder}</label>
            {/* {children} */}

            {errorMessage
                ? <div className="error">{errorMessage}</div>
                : null
            }
        </div>
    )
}
